module.exports = __webpack_public_path__ + "static/media/monitor.4bce704e.jpg";